import React from 'react';
import cx from 'classnames';
import './MedicalQuestionContainer.scss';

export const MedicalQuestionContainer = ({ children, button, isActive }) => {
  return (
    <div
      className={cx('medical-question-container', {
        'medical-question-container--is-active': isActive,
      })}
    >
      {children}
      <div>{button}</div>
    </div>
  );
};
